import { render, staticRenderFns } from "./ButtonClearSubmit.vue?vue&type=template&id=b5615cfc&"
import script from "./ButtonClearSubmit.vue?vue&type=script&lang=js&"
export * from "./ButtonClearSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports